import { Environment } from '@t-llevo/util';

class EnvironmentImpl implements Environment {
  production = false;
  apiUrl = 'https://dev-apitllevo.edtsoft.cu/';
  logoutUrl = 'logout';
  refreshTokenUrl = 'refresh';
  tokenHeaderKey = 'Authorization';
}

export const environment = new EnvironmentImpl();
